import { findElement } from "store/selectors/pageSelector";
import { updateElement } from "store/actions/pageActions";

class TextManager {
  constructor(store) {
    this.store = store;
    this.db = {};
    window.ReduxSubscriber.subscribe(
      "MOVE_ELEMENT",
      this.handleElementMoving.bind(this)
    );
  }

  getElement(key) {
    return findElement(this.store.getState(), key);
  }

  handleElementMoving(payload) {
    if (
      (payload.component && payload.component === "Text") ||
      payload.component === "Title"
    ) {
      // console.log("TEXT MANAGER: ELEMENTO MOVEU");
      const instance = this.db[payload.source];
      if (!instance.synced) {
        this.sync(payload.source);
      }
    }
  }

  register(id, text) {
    // console.log("Registra texto");
    const obj = {
      text,
      synced: true,
    };
    this.db[id] = obj;
  }

  update(id, text) {
    // console.log("Atualiza texto");
    const newEntry = {
      text,
      synced: false,
    };
    this.db[id] = newEntry;
  }

  /**
   * Returns whether or not all texts intances are synced within redux store
   */
  isTextsSynced() {
    return Object.keys(this.db).every((key) => {
      const textInstance = this.db[key];
      return textInstance.synced;
    });
  }

  /**
   * Syncs an entry in local db store with the redux store
   *
   * @param {String} key identifier in db store
   * @memberof TextManager
   */
  sync(key, text = null) {
    // console.log("Sync db com store");

    // update the entry before syncing one last time
    // if text is provided
    if (text) {
      this.update(key, text);
    }

    const entry = this.db[key];

    // update redux store
    const element = this.getElement(key);
    const newElement = {
      ...element,
      props: {
        ...element.props,
        children: entry.text,
      },
    };
    this.store.dispatch(updateElement(newElement));

    this.db[key] = {
      text: entry.text,
      synced: true,
    };
  }

  /**
   * for each entry in the db store, sync it with the
   * redux store and set it as updated,
   *
   * @returns {Promise}
   * @memberof TextManager
   */
  syncAll() {
    return new Promise((resolve, reject) => {
      try {
        const keys = Object.keys(this.db).filter((key) => {
          return !this.db[key].synced;
        });
        for (const key of keys) {
          this.sync(key);
        }
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
}

export default TextManager;
